let selectedPlace = '';
export const INITIAL = path => {
  if (path) {
    selectedPlace = path;
  }
  return selectedPlace;
};
